import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { LeadBulkUploadService } from './lead-bulk-upload.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-lead-bulk-upload',
  templateUrl: './lead-bulk-upload.component.html',
  styleUrls: ['./lead-bulk-upload.component.scss']
})
export class LeadBulkUploadComponent implements OnInit {
  @ViewChild('validationError') validationErrorModel!: TemplateRef<any>;
  @ViewChild('fileSample') filePreviewModal!: TemplateRef<any>;
  @ViewChild('mapFields') mapFieldsTemplate!: TemplateRef<any>;
  isLoading: Subject<boolean> = new Subject<boolean>();

  @ViewChild('fileInput') fileInput!: ElementRef;
  displayedColumns: string[] = ['First Name', 'Last Name', 'Email ID', 'Mobile', 'Gender', 'Source', 'Product Category', 'Product Model', 'Remarks', 'Stage', 'Sales Manager'];
  public ELEMENT_DATA: any = [
    {
      "Name": "Revathy",
      "Email ID": "revathy@gmail.com",
      "Mobile": "9086478547",
      "Gender": "Female",
      "Source": "Organic",
      "Product Category": "Big Bikes",
      "Product Model": "Gixxer 250",
      "Remarks": "Test drive",
      "Stage": "New",
      "Sales Manager": 'sales1@gmail.com'
    },
    {
      "Name": "Janani",
      "Email ID": "Janani@gmail.com",
      "Mobile": "9086478548",
      "Gender": "Female",
      "Source": "Google",
      "Product Category": "Motorcycles",
      "Product Model": "Gixxer SF",
      "Remarks": "Test drive",
      "Stage": "New",
      "Sales Manager": 'sales2@gmail.com'
    },
    {
      "Name": "Harish",
      "Email ID": "harish@gmail.com",
      "Mobile": "9086478549",
      "Gender": "Male",
      "Source": "Offline",
      "Product Category": "Scooters",
      "Product Model": "Access 125",
      "Remarks": "Interested to buy",
      "Stage": "Assigned",
      "Sales Manager": 'sales1@gmail.com'
    }
  ]

  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  headers: any = [];
  fields: any = [{ label: "First Name", key: "first_nameMap" },
  { label: "Last Name (optional)", key: "last_nameMap" },
  { label: "Email ID", key: "emailMap" },
  { label: "Mobile", key: "mobileMap" },
  { label: "Gender (optional)", key: "genderMap" },
  { label: "Base Source", key: "base_lead_sourceMap" },
  { label: "Source", key: "lead_sourceMap" },
  { label: "Sub Source", key: "lead_sub_sourceMap" },
  { label: "Product Category", key: "product_categoryMap" },
  { label: "Product Model", key: "product_modelMap" },
  { label: "Variant", key: "product_variantMap" },
  { label: "Color", key: "product_colorMap" },
  { label: "Customer Interest (optional)", key: "customerInterestMap" },
  { label: "Finance Source", key: "financeMap" },
  { label: "Remarks (optional)", key: "pre_sales_remarkMap" },
  { label: "Stage", key: "stageMap" },
  { label: "Sales Manager", key: "assign_toMap" },
  // { label: "Followup Reason", key: "followup_reasonMap" },
  { label: "Next Followup Date (optional)", key: "next_followup_dateMap" },
    // { label: "No Response Reason", key: "no_resonse_reasonMap" },
    // { label: "Lost Reason", key: "lost_reasonMap" },
    // { label: "Junk Reason", key: "junk_reason" }
  ];
  mappedFields: any = { 'first_nameMap': '', 'last_nameMap': '', 'emailMap': '', 'mobileMap': '', 'genderMap': '', 'base_lead_sourceMap': '', 'lead_sourceMap': '', 'lead_sub_sourceMap': '', 'product_modelMap': '', 'product_variantMap': '', 'product_colorMap': '' ,'stageMap': '', 'product_categoryMap': '', 'pre_sales_remarkMap': '', 'assign_toMap': '', 'followup_reasonMap': '', 'next_followup_dateMap': '', 'no_resonse_reasonMap': '', 'lost_reasonMap': '', 'junk_reason': '', 'customerInterestMap': '', 'financeMap': '' };

  constructor(public dialog: MatDialog, private toastr: ToastrService, private leadBulkService: LeadBulkUploadService) { }
  ngOnInit(): void {
    // const selectedItem = document.getElementById('create-lead');
    // if (selectedItem) {
    //   selectedItem.classList.add('active');
    // }
    if (sessionStorage.getItem('masters')) {
      const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
      if (masters) {
        this.stages = masters?.leadStage;
      }
    }
    this.getSampleData();
  }

  selectedStage: string = '';
  stages: any = [];
  file: File | any = null;
  uploadedFile: File | any = null;

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onFileDrop(event: any) {
    event.preventDefault();
    this.file = event.dataTransfer.files[0];
    if (event.dataTransfer && event.dataTransfer.files.length) {
      this.validateFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    // const files: FileList = event.target.files;
    this.file = event.target.files[0];
    if (input.files && input.files.length) {
      this.validateFile(input.files[0]);
    }
  }

  validateFile(file: File) {
    const validExtensions = ['csv', 'xlsx', 'xls'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const fileSize = file.size;

    if (fileExtension && validExtensions.includes(fileExtension)) {
      if (fileSize <= maxSizeInBytes) {
        this.uploadedFile = file;
        this.extractHeaders(this.uploadedFile);
      } else {
        this.toastr.error('File size exceeds 10MB!');
        this.uploadedFile = null;
        this.file = null;
      }
    } else {
      this.toastr.error('Invalid file type!');
      this.uploadedFile = null;
      this.file = null;
    }
  }

  validationData: any = []
  uploadFile() {
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      formData.append('first_nameMap', this.mappedFields.first_nameMap);
      formData.append('last_nameMap', this.mappedFields.last_nameMap);
      formData.append('emailMap', this.mappedFields.emailMap);
      formData.append('mobileMap', this.mappedFields.mobileMap);
      formData.append('genderMap', this.mappedFields.genderMap);
      formData.append('base_lead_sourceMap', this.mappedFields.base_lead_sourceMap);
      formData.append('lead_sourceMap', this.mappedFields.lead_sourceMap);
      formData.append('lead_sub_sourceMap', this.mappedFields.lead_sub_sourceMap);
      formData.append('product_modelMap', this.mappedFields.product_modelMap);
      formData.append('product_variantMap', this.mappedFields.product_variantMap);
      formData.append('product_colorMap', this.mappedFields.product_colorMap);
      formData.append('product_categoryMap', this.mappedFields.product_categoryMap);
      formData.append('customerInterestMap', this.mappedFields.customerInterestMap ? this.mappedFields.customerInterestMap : '');
      formData.append('financeMap', this.mappedFields.financeMap ? this.mappedFields.financeMap : '');
      formData.append('pre_sales_remarkMap', this.mappedFields.pre_sales_remarkMap);
      formData.append('stageMap', this.mappedFields.stageMap);
      formData.append('assign_toMap', this.mappedFields.assign_toMap ? this.mappedFields.assign_toMap : '');
      formData.append('followup_reasonMap', this.mappedFields.followup_reasonMap ? this.mappedFields.followup_reasonMap : '');
      formData.append('next_followup_dateMap', this.mappedFields.next_followup_dateMap ? this.mappedFields.next_followup_dateMap : '');
      formData.append('no_resonse_reasonMap', this.mappedFields.no_resonse_reasonMap ? this.mappedFields.no_resonse_reasonMap : '');
      formData.append('lost_reasonMap', this.mappedFields.lost_reasonMap ? this.mappedFields.lost_reasonMap : '');
      formData.append('junk_reason', this.mappedFields.junk_reason ? this.mappedFields.junk_reason : '');

      this.validationData = [];
      this.leadBulkService.bulkUpload(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          this.onMapFieldsClose();
          this.toastr.success(res.body.responseMessage);
        } else {
          this.validationData = res.body.data;
          this.onMapFieldsClose();
          this.toastr.error(res.body.responseMessage);
          this.openValidations();
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }

  openValidations() {
    this.dialog.open(this.validationErrorModel, {
      width: '600px',
      height: '70vh'
    });
  }

  deleteFile(): void {
    this.uploadedFile = null;
    this.clearMappedFields();
    // this.fileInput.nativeElement.value = '';
  }

  openFile() {
    this.dialog.open(this.filePreviewModal, {
      width: '800px',
      height: '85vh'
    });
  }

  onClose() {
    this.dialog.closeAll();
  }

  extractHeaders(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      // Assuming the first sheet
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const headers: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];

      this.headers = headers.map((header: any, index: number) => ({ position: index + 1, field: header }));
    };
    reader.readAsArrayBuffer(file);
  }

  openMapFieldsDialog(): void {
    this.dialog.open(this.mapFieldsTemplate, {
      width: '500px',
      height: '500px'
    });
  }

  onMapFieldsClose(): void {
    this.dialog.closeAll();
  }

  downloadFile() {

    const url = this.fileLink;
    const link = document.createElement('a');
    link.href = url;
    link.download = 'FILENAME'; // Optional: specify the filename
    link.click();
  }

  clearMappedFields() {
    for (const key in this.mappedFields) {
      if (this.mappedFields.hasOwnProperty(key)) {
        this.mappedFields[key] = '';
      }
    }
  }

  sampleData: any = []
  productCategory: any = '';
  productModel = '';
  leadStage: any = '';
  baseLeadSource: any = ''
  leadSources: any = '';
  leadSubSources: any = '';
  salesUsers: any = '';
  customerInterest: any = ''
  finance: any = ''
  fileLink: any = null;
  baseLeadAll: any = []
  leadSourceAll: any = []
  productColors: any = []
  productModels: any = []

  getSampleData() {
    this.leadBulkService.getSampleData().subscribe((res: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
      let responseData: any = res.body;
      if (responseData.responseCode == 200) {
        this.sampleData = responseData.data
        this.productCategory = this.sampleData?.productCategories
        this.leadStage = this.sampleData.allLeadStages?.map((item: any) => item.lead_stage).join(', ')
        this.baseLeadAll = this.sampleData.allBaseLeadSources
        this.leadSourceAll = this.sampleData.allLeadsources
        this.baseLeadSource = this.sampleData.allBaseLeadSources?.map((item: any) => item.base_lead_source).join(', ')
        this.leadSources = this.sampleData.allLeadsources?.map((item: any) => item.lead_source).join(', ')
        this.leadSubSources = this.sampleData.allLeadSubsources?.map((item: any) => item.lead_sub_source).join(', ')
        this.salesUsers = this.sampleData.users?.map((item: any) => item.email).join(', ')
        this.customerInterest = this.sampleData.customerInterestData?.map((item: any) => item.interest).join(', ')
        this.finance = this.sampleData.financeData?.map((item: any) => item.finance).join(', ');
        this.fileLink = this.sampleData.link;
        this.productColors = this.sampleData.product_colors;
        this.productModels = this.sampleData?.productCategories.map((category:any) => {
          return category.productModels.map((model:any) => ({
            model: model.model,
            product_variants: model.product_variants,
          }));
        }).flat();
      } else {
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });

  }
}
